const language = {
    'pt': 
        {
            add_new:            'Adicionar novo',
            address:             'Morada',
            address_placeholder: 'Introduza a morada',
            age:                'Idade',
            age_placeholder:                'Introduza a idade',
            back:               'Voltar',
            cancel:             'Cancelar',
            close:              'Fechar',
            config:             'Configuração',
            contact_email:      'Email de contacto',
            contact_email_placeholder:      'Introduza o email de contacto',
            content:            'Conteúdo',
            content_edit:       'Editar conteúdo',
            content_new:        'Novo conteúdo',
            content_list:       'Lista de conteúdos',
            dark_mode:               'Dark mode',
            dates:              'Datas',
            date_birth:         'Data de nascimento',
            date_birth_placeholder:         'Introduza a data de nascimento',
            date_creation:      'Criação',
            date_publication:   'Publicação',
            date_last_update:   'Última actualização',
            delete:             'Eliminar',
            delete_title:       'Eliminar Registo',
            delete_text:        'Tem a certeza que pretende continuar?',
            delete_confirm:     'Sim',
            delete_cancel:      'Não',
            delete_error:       'Problema ao apagar registo!',
            delete_success:     'Registo apagado com sucesso!',
            description:        'Descrição',
            description_placeholder: 'Introduza uma descrição',
            edit:               'Editar',
            edit_title:         'Editar Registo',
            edit_text:          'Tem a certeza que pretende continuar?',
            edit_text_2:         'Ao atualizar os seus dados, concorda com os nossos ',
            edit_confirm:       'Sim',
            edit_cancel:        'Não',
            edit_error:         'Problema ao actualizar registo!',
            edit_success:       'Registo actualizado com sucesso!',
            educational_background: 'Habilitações académicas',
            email:              'E-mail',
            email_contact:      'E-mail preferencial de contacto',   
            email_error_message:  'Campo inválido. Inclua um "@" no endereço de e-mail.',
            entity:             'Formador',  
            entity_edit:        'Editar formador',                
            entity_new:         'Novo formador',                
            entity_list:        'Lista de formadores', 
            entrepreneur:               'Empreendedor',
            entrepreneur_edit:          'Editar empreendedor',
            entrepreneur_list:          'Lista de Empreendedores',
            filter_placeholder: 'Procurar',
            formation_area:     'Área de formação',
            formation_area_placeholder:  'Introduza a área de formação',
            id:                 'ID',
            id_number:          'Número de identificação',
            id_number_placeholder:          'Introduza o número de identificação',
            id_type:            'Tipo de Identificação',
            id_type_citizen_card: 'Cartão do Cidadão',
            id_type_identity_card: 'Bilhete de Identidade',
            id_type_passport:   'Passaporte',
            id_validity:         'Validade',
            image:              'Imagem',
            image_profile:              'Imagem de perfil',
            image_choose:       'Escolher imagem',
            image_remove:       'Remover imagem',
            insert_title:       'Novo Registo',
            insert_text:        'Tem a certeza que pretende continuar?',
            insert_confirm:     'Sim',
            insert_cancel:      'Não',
            insert_error:       'Problema ao inserir registo!',
            insert_success:     'Registo inserido com sucesso!',
            language:           'Lingua',
            login_data:         'Dados de login',
            municipality:       'Concelho',
            municipality_placeholder:       'Introduza o concelho',
            name:               'Nome',
            name_full:               'Nome completo',
            name_full_placeholder:   'Introduza o nome completo',
            name_placeholder:   'Introduza o nome',
            nib_iban_placeholder: 'Introduza o NIB/IBAN',
            nif_placeholder:    'Introduza o NIF (9 dígitos)',
            surname:            'Apelido',
            surname_placeholder:'Introduza o apelido',
            location:           'Localidade',
            location_placeholder:'Introduza a localidade',
            password:           'Password',
            password_confirmation:  'Confirmação da Password',
            password_placeholder:   'Introduza a password',
            password_title:     'Password!',
            password_text:      'As Passwords não correspondem.',
            password_confirm:   'Continue',
            password_cancel:    'No',
            password_error:     'Problem inserting element!',
            password_success:   'Successful inserted element!', 
            personal_data:      'Dados pessoais',
            phone_number:       'Contacto telefónico',
            phone_number_placeholder:       'Introduza o contacto telefónico',
            place_birth:        'Naturalidade',
            place_birth_placeholder:        'Introduza a naturalidade',
            postal_code:        'Código-postal',
            postal_code_placeholder:       '9999-999',
            principal:          'Principal',
            professional_area:  'Área profissional',
            professional_area_placeholder:  'Introduza a área profissional',
            profile:            'Perfil',
            remove:             'Remover',
            table_rows_per_page:'Registos por página:',
            table_separator:    'de',
            table_all:          'Todos',
            table_thumbnail:    'Thumbnail',
            table_title:        'Título',
            table_parent:       'Parent',
            table_date:         'Data',
            table_type:         'Tipo',
            table_count:        'Count',
            table_state:        'Estado',
            table_actions:      'Acções',
            table_empty:        'sem resultados',
            terms_conditions_link:   'termos e condições.',
            terms_conditions_required: 'Os campos assinalados com (<span className="text-danger">&#42;</span>) são de preenchimento obrigatório.',
            text:               'Texto',
            title:              'Título',
            title_placeholder:  'Introzuda o título',
            trainer:            'Formador',
            trainer_list:       'Lista de formadores',
            save:               'Salvar', 
            username:           'Username', 
            username_email:     'Email de utilizador',
            username_placeholder: 'Introduza o username', 
            view:               'Ver',
            village:            'Freguesia',
            village_placeholder:            'Introduza a freguesia',
            warning_title:      'Aviso!',
            warning_text_1:       'Já existe um registo com este email de utilizador.',
            warning_text_2:       'Já existe um registo com este email de contacto.',
            warning_confirm:    'Continuar',
            warning_cancel:     'Não',
            warning_error:      'Problema ao inserir registo!',
            warning_success:    'Registo inserido com sucesso!',             
        },
    'en':
        {
            add_new:            'Add new',
            address:             'Address',
            address_placeholder: 'Insert address',
            age:                'Age',
            age_placeholder:                'Insert age',
            back:               'Go back',
            cancel:             'Cancel',
            close:              'Close',
            config:              'Clonfiguration',
            content:            'Content',
            content_edit:       'Edit content',
            content_new:        'New content',
            content_list:       'Content list',
            dates:              'Dates',
            date_birth:         'Data of birth',
            date_birth_placeholder:         'Insert the date o birth',
            date_creation:      'Creation',
            date_publication:   'Publication',
            date_last_update:   'Last update',
            delete:             'Delete',
            delete_title:       'Delete Regist',
            delete_text:        'Are you sure you want to continue?',
            delete_confirm:     'Yes',
            delete_cancel:      'No',
            delete_error:       'Problem deleting the element!',
            delete_success:     'Element deleted successfully!',
            description:        'Description',
            description_placeholder: 'Insert a description',
            edit:               'Edit',
            edit_title:         'Edit Regist',
            edit_text:          'Are you sure you want to continue?',
            edit_text_2:         'By updating your information, you agree with your ',
            edit_confirm:       'Yes',
            edit_cancel:        'No',
            edit_error:         'Problem updating element!',
            edit_success:       'Successful updated element!',
            educational_background: 'Educacional background',
            email:              'E-mail',
            email_contact:      'Contact e-mail',   
            email_error_message:  'Invalid field. Include an "@" in the email address.',
            entity:             'Trainer', 
            entity_edit:        'Edit trainer', 
            entity_new:         'New trainer', 
            entity_list:        'Trainer List', 
            entrepreneur:       'Entrepeneur',
            entrepreneur_edit:  'Edit entrepeneur',
            entrepreneur_list:  'Entrepeneur List',
            filter_placeholder: 'Search',
            formation_area:     'Formation area',
            formation_area_placeholder:  'Insert formation area',
            id:                 'ID',
            id_number:          'Identification Number',
            id_number_placeholder:          'Insert identification number',
            id_type:            'Identification Type',
            id_type_citizen_card: 'Citizen Card',
            id_type_identity_card: 'Identity Card',
            id_type_passport:   'Passaport',
            id_validity:         'Validity',
            language:           'Language',
            login_data:         'Login data',
            municipality:       'Municipality',
            municipality_placeholder:       'Insert municipality',
            name:               'Name',
            name_full:          'Full name',
            name_full_placeholder:          'Insert full name',
            name_placeholder:   'Insert the name',
            nib_iban_placeholder: 'Insert NIB/IBAN',
            nif_placeholder:    'Insert NIF (9 digits)',
            surname:            'Apelido',
            surname_placeholder:'Introduza o apelido',
            location:           'Location',
            location_placeholder:'Insert location',
            contact_email:      'Contact email',
            contact_email_placeholder:    'Insert email contact',
            image:              'Image',
            image_profile:      'Profile image',
            image_choose:       'Choose imagem',
            image_remove:       'Remove image',
            insert_title:       'New Regist',
            insert_text:        'Are you sure you want to continue?',
            insert_confirm:     'Yes',
            insert_cancel:      'No',
            insert_error:       'Problem updating element!',
            insert_success:     'Successful updated element!',
            password:           'Password',
            password_confirmation: 'Password confirmation',
            password_placeholder:   'Insert password',
            password_title:     'Password!',
            password_text:      'The password do not match.',
            password_confirm:   'Continue',
            password_cancel:    'No',
            password_error:     'Problem inserting element!',
            password_success:   'Successful inserted element!', 
            personal_data:      'Personal data',
            phone_number:       'Phone number',
            phone_number_placeholder:       'Insert your phone number',
            place_birth:        'Place of birth',
            place_birth_placeholder:        'Insert place of birth',
            postal_code:        'Postal code',
            postal_code_placeholder:       '9999-999',
            principal:          'Principal',
            professional_area:  'Professional area',
            professional_area_placeholder:  'Insert professional area',
            profile:            'Profile',
            remove:             'Remove',
            table_rows_per_page:'Regist by page:',
            table_separator:    'of',
            table_all:          'All',
            table_thumbnail:    'Thumbnail',
            table_title:        'Title',
            table_parent:       'Parent',
            table_date:         'Date',
            table_type:         'Type',
            table_count:        'Count',
            table_state:        'State',
            table_actions:      'Actions',
            table_empty:        'no results',
            terms_conditions_link:   'terms and conditions.',
            terms_conditions_required: 'The fields marked with (<span style="color: var(--red)">&#42;</span>) are required.',
            text:               'Text',
            title:              'Title',
            title_placeholder:  'Insert title',
            trainer:            'Formador',
            trainer_list:       'Lista de formadores',
            save:               'Save',
            username:           'Username',
            username_email:     'Username email', 
            username_placeholder: 'Insert the username',
            view:               'View',
            village:            'Village',
            village_placeholder:            'Insert village',
            warning_title:      'Warning!',
            warning_text_1:       'There is already a record with this username email.',
            warning_text_2:       'There is already a record with this contact email.',
            warning_confirm:    'Continue',
            warning_cancel:     'No',
            warning_error:      'Problem inserting element!',
            warning_success:    'Successful inserted element!', 
        }
}

module.exports = {
    language
};